import { FC, SVGProps } from 'react';
import { styled } from '@mui/material/styles';

export interface DefaultThemeSVGProps extends SVGProps<SVGSVGElement> {
  SVG: FC<SVGProps<SVGSVGElement>>;
}

export const DefaultThemeSVG: FC<DefaultThemeSVGProps> = ({ SVG }) => {
  const StyledThemeSVG = styled(SVG)(({ theme: { palette } }) => ({
    '*': { fill: palette.secondary.dark },
  }));

  return <StyledThemeSVG />;
};
